"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDateObject = exports.convertHours24 = exports.convertTimeObject = exports.convertString24hr = exports.convertString12hr = void 0;
var index_1 = require("../../common/index");
var is_1 = require("../is/is");
var regex_1 = require("../regex/regex");
var utils_1 = require("../utils/utils");
var validate_1 = require("../validate/validate");
exports.convertString12hr = function (string12hr) {
    validate_1.validateString12hr(string12hr);
    return {
        to24hr: function () {
            if (/-/.test(string12hr))
                return '';
            var timeObject = exports.convertString12hr(string12hr).toTimeObject();
            return exports.convertTimeObject(timeObject).to24hr();
        },
        toTimeObject: function () {
            var result = regex_1.regex.string12hr.exec(string12hr) || [];
            var _a = [
                utils_1.toNumber(result[1]),
                utils_1.toNumber(result[2]),
                (result[3] === '--' ? null : result[3]),
            ], hrs12 = _a[0], minutes = _a[1], mode = _a[2];
            var getHrs24 = function () {
                if (typeof hrs12 === 'number') {
                    if (mode === null && hrs12 === 12) {
                        return 0;
                    }
                    if (mode === 'PM') {
                        if (hrs12 === 12) {
                            return 12;
                        }
                        else if (hrs12 + 12 > 23) {
                            return (hrs12 + 12 - 24);
                        }
                        else {
                            return (hrs12 + 12);
                        }
                    }
                    else if (mode === 'AM' && hrs12 === 12) {
                        return 0;
                    }
                    else {
                        return hrs12;
                    }
                }
                return null;
            };
            var nullifyDashes = function (value) {
                return value === '--' ? null : value;
            };
            var newMode = nullifyDashes(mode);
            var hrs24 = newMode ? getHrs24() : null;
            var timeObject = {
                hrs24: hrs24,
                hrs12: nullifyDashes(hrs12),
                minutes: nullifyDashes(minutes),
                mode: newMode,
            };
            validate_1.validateTimeObject(timeObject);
            return timeObject;
        },
    };
};
exports.convertString24hr = function (string24hr) {
    validate_1.validateString24hr(string24hr);
    return {
        to12hr: function () {
            if (string24hr === index_1.blankValues.string24hr) {
                return index_1.blankValues.string12hr;
            }
            var timeObject = exports.convertString24hr(string24hr).toTimeObject();
            return exports.convertTimeObject(timeObject).to12hr();
        },
        toTimeObject: function () {
            if (string24hr === index_1.blankValues.string24hr) {
                return index_1.blankValues.timeObject;
            }
            // string24hr
            var regResult = regex_1.regex.string24hr.exec(string24hr) || [];
            var _a = [regResult[1], regResult[2]], hrsString24 = _a[0], minString = _a[1];
            var _b = [utils_1.toNumber(hrsString24), utils_1.toNumber(minString)], hrs24 = _b[0], minutes = _b[1];
            var timeObject = {
                hrs24: hrs24,
                hrs12: exports.convertHours24(hrs24).toHours12(),
                minutes: minutes,
                mode: (is_1.isAmString24hr(string24hr) && 'AM') ||
                    (is_1.isPmString24hr(string24hr) && 'PM') ||
                    null,
            };
            validate_1.validateTimeObject(timeObject);
            return timeObject;
        },
    };
};
exports.convertTimeObject = function (timeObject, skipValidation) {
    if (skipValidation === void 0) { skipValidation = false; }
    if (!skipValidation) {
        validate_1.validateTimeObject(timeObject);
    }
    var hrs24 = timeObject.hrs24, hrs12 = timeObject.hrs12, minutes = timeObject.minutes, mode = timeObject.mode;
    var hrsString24 = utils_1.toLeadingZero(hrs24);
    var hrsString12 = utils_1.toLeadingZero(hrs12);
    var minString = utils_1.toLeadingZero(minutes);
    return {
        to12hr: function () { return hrsString12 + ":" + minString + " " + (mode || '--'); },
        to24hr: function () {
            var string24hr = hrsString24 + ":" + minString;
            if (/-/.test(string24hr))
                return '';
            return string24hr;
        },
    };
};
exports.convertHours24 = function (hours24) {
    validate_1.validateHours24(hours24);
    var getHours12 = function () {
        if (typeof hours24 === 'number') {
            if (hours24 <= 12) {
                if (hours24 === 0) {
                    return 12;
                }
                else {
                    return hours24;
                }
            }
            else {
                return (hours24 - 12);
            }
        }
        return hours24;
    };
    return {
        toHours12: function () { return getHours12(); },
    };
};
exports.convertDateObject = function (date) {
    return {
        to12hr: function () {
            var timeObject = exports.convertDateObject(date).toTimeObject();
            return exports.convertTimeObject(timeObject).to12hr();
        },
        to24hr: function () {
            var timeObject = exports.convertDateObject(date).toTimeObject();
            return exports.convertTimeObject(timeObject).to24hr();
        },
        toTimeObject: function () {
            var _a = [date.getHours(), date.getMinutes()], hrs24 = _a[0], minutes = _a[1];
            var hrs12 = exports.convertHours24(hrs24).toHours12();
            var mode = is_1.isAmHrs24(hrs24) ? 'AM' : 'PM';
            return { hrs24: hrs24, hrs12: hrs12, minutes: minutes, mode: mode };
        },
    };
};
